import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { IApp } from "../../../../models/application/i-app";
import { appRestClientInjectionToken } from "../../../../rest-clients/application/app/app-rest-client-injection-token";
import { IAppRestClient } from "../../../../rest-clients/application/app/i-app-rest.client";
import { IPage } from "@zaeper/communication-lib";

@Injectable()
export class AppPageResolver implements Resolve<IPage<IApp>> {
  constructor(@Inject( appRestClientInjectionToken ) private readonly _appRestClient: IAppRestClient) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<IPage<IApp>> {
    return this._appRestClient.getAppPage( {
      pageNumber: 0,
      pageSize: 100
    } )
  }
}
